module.exports = __webpack_public_path__ + "img/r-rachel-park-366508-unsplash-min-200x132.41193062.jpg";